import React from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, CartesianGrid } from "recharts";
import "../App.css"

export default function BarChartVer({ data, xAxisKey, yAxisKey, bars, layout = "vertical" }) {
  return (
    <BarChart
      width={1600}
      height={800}
      data={data}
      layout={layout}
      margin={{ top: 20, right: 50, bottom: 50, left: 100 }}
    >
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis type="number"  />
      <YAxis dataKey={xAxisKey} type="category" />
      <Tooltip />
      <Legend />
      {bars.map((bar, index) => (
        <Bar key={index} dataKey={bar.dataKey} fill={bar.fill} name={bar.name} stackId={bar.stackId} />
      ))}
    </BarChart>
  );

}
